"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function resolveGlobUrlFactory(glob, path) {
  return function (url) {
    var includePaths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var filePaths = new Set();

    if (glob.hasMagic(url)) {
      includePaths.forEach(function (includePath) {
        var globPaths = glob.sync(url, {
          cwd: includePath
        });
        globPaths.forEach(function (relativePath) {
          filePaths.add(path.resolve(includePath, relativePath) // This fixes a problem with importing absolute paths on windows.
          .split("\\").join("/"));
        });
      });
      return _toConsumableArray(filePaths);
    }

    return null;
  };
}

exports.resolveGlobUrlFactory = resolveGlobUrlFactory;